import { useSelector } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { Tabs } from '@pmi/dsm-react';
import { accountSelector } from '../../shared/store/shared/accountSlice';
import styles from './logs.module.scss';
import usePermissions from '../../shared/hooks/usePermissions';
import Permissions from '../../shared/permissions';
import AuditLogs from './AuditLogs';
import EnrollmentLogs from './EnrollmentLogs';
import ChangeLog from './ChangeLogs';
import ErrorLogs from './ErrorLogs';
import SharePermissionLogs from './SharePermissionLogs';
import logSearchHelper from './LogSearchField/helper';
import { useClearAlertMessages } from '../../shared/components/AlertGroup/useAccountAlerts';

export default function AdminLogs() {
  useClearAlertMessages();
  const { currentAccountId } = useSelector(accountSelector);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const { hasAccess, isLoading } = usePermissions();
  const isDeveloper = useMemo(
    () =>
      hasAccess({
        permissions: [Permissions.ManagePMIDeveloper],
      }),
    [currentAccountId, isLoading],
  );
  const tabLabels = useMemo(() => {
    const tabs = [
      { label: 'Audit Log', value: 'audit' },
      { label: 'Enrollment Log', value: 'enrollment' },
      { label: 'Change Log', value: 'change' },
      { label: 'Error Log', value: 'error' },
      { label: 'Share Permission Log', value: 'sharePermission' },
    ];
    if (!isDeveloper) {
      tabs.shift();
    }
    setSelectedTabIndex(0);
    return tabs;
  }, [isDeveloper]);

  const selectedTab = tabLabels[selectedTabIndex].value;
  useEffect(() => {
    logSearchHelper.clearStoredSearch();
  }, []);
  return (
    <div className={`box ${styles['logs-container']}`}>
      <Tabs
        theme="light"
        labels={tabLabels}
        onChange={(evt, index) => {
          setSelectedTabIndex(index);
        }}
        value={selectedTabIndex}
      />

      {isDeveloper && selectedTab === 'audit' && <AuditLogs />}
      {selectedTab === 'enrollment' && <EnrollmentLogs />}
      {selectedTab === 'change' && <ChangeLog />}
      {selectedTab === 'error' && <ErrorLogs />}
      {selectedTab === 'sharePermission' && <SharePermissionLogs />}
    </div>
  );
}
